import { UniqueConstraintError } from '@repo/shared'

import type { TFunction } from 'i18next'

export function getApiErrorMessage(
  error: Error & { status?: number },
  t: TFunction,
  fallback: string,
): string {
  const status = error.status

  if (!status) return t('common:errors.networkError')
  if (status === 429) return t('common:errors.tooManyAttempts')

  if (status === 409) {
    if (error.message === 'TACHOSYNC_COMPANY_NOT_CONFIGURED')
      return t('common:errors.tachosyncCompanyNotConfigured')
    if (error.message === UniqueConstraintError.LicensePlateExists)
      return t('common:errors.licensePlateExists')
    if (error.message === UniqueConstraintError.VinExists)
      return t('common:errors.vinExists')
    if (error.message === UniqueConstraintError.LicenseNumberExists)
      return t('common:errors.licenseNumberExists')
    if (error.message === UniqueConstraintError.TachographCardExists)
      return t('common:errors.tachographCardExists')
    if (error.message === UniqueConstraintError.PassportNumberExists)
      return t('common:errors.passportNumberExists')
    if (error.message === UniqueConstraintError.IdentityCardExists)
      return t('common:errors.identityCardExists')
    if (error.message === UniqueConstraintError.EmailExists)
      return t('common:errors.emailExists')
    if (error.message === UniqueConstraintError.DeviceIdentExists)
      return t('common:errors.deviceIdentExists')
    if (error.message === UniqueConstraintError.VehicleRouteInProgress)
      return t('common:errors.vehicleRouteInProgress')
    return fallback
  }

  return fallback
}
